import React from "react";
import { Table, Button, Tooltip } from "antd";
import { SettingOutlined } from "@ant-design/icons";

export default function LpgCargoCompressorTable({ data, onEdit }) {
  const columns = [
    {
      title: "LPG Cargo Compressor Name",
      dataIndex: "lpg_name",
      key: "lpg_name",
      align: "center",
    },
    {
      title: "LPG Cargo Compressor Maker",
      dataIndex: "lpg_maker",
      key: "lpg_maker",
      align: "center",
    },
    {
      title: "LPG Cargo Compressor Model",
      dataIndex: "lpg_model",
      key: "lpg_model",
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Tooltip title="Configure parameters">
          <Button
            type="primary"
            size="small"
            onClick={() => onEdit?.(record)}
            style={{ marginRight: "5px" }}
            icon={<SettingOutlined />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      bordered
      pagination={{ pageSize: 10 }}
      rowKey="key"
      className="custom-table"
    />
  );
}
